//https://www.jacklmoore.com/notes/rounding-in-javascript/
export const roundToNDecimalPlaces = (value: number, n: number) =>
  Number(Math.round(Number(value + "e" + n)) + "e-" + n);

export const roundUpToNDecimalPlaces = (value: number, n: number) =>
  Number(Math.ceil(Number(value + "e" + n)) + "e-" + n);

export const percentageAsDecimal = (value: number) =>
  roundToNDecimalPlaces(value / 100, 2);
